import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Error } from "../layout/Error";
import "react-datetime/css/react-datetime.css";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { TimePicker as MuiTimePicker, DatePicker as MuiDatePicker } from "@material-ui/pickers";
import { TextField, IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
  },
  icon: {
    color: "black",
    width: 25,
    height: 25,
  },
  inputRow: {
    width: "100%",
    display: "flex",
    cursor: "pointer",
    fontWeight: "500",
    color: "black",

    // "&:hover": {
    //   borderBottom: "1px solid black",
    // },
    "& span": {
      marginRight: "10px",
    },
  },
  inputRow2: {
    position: "relative",
    display: "flex",
    cursor: "pointer",
    fontWeight: "500",
    color: "black",
    "& span": {
      position: "absolute",
      marginRight: "10px",
    },
  },
  timePicker: {
    width: "100%",
  },

  timePickerMain: {
    fontWeight: "600",
    padding: '5px 0px',
    position: 'relative',
    bottom: 5,
    width: "100% !important",
  },
  dateTimePicker: {
    marginRight: "6px",
  },
}));

// export const DatePicker = ({fieldProps, children, ...props}) => {

//     const { fieldState: { isTouched, error } } = fieldProps
//     const { field } = fieldProps
//     const classes = useStyles()

//     

//     return (
//         <>
//           <KeyboardDatePicker clearable
//                               inputRef={field.ref}
//                               onChange={field.onChange}
//                               value={field.value}
//                               format = "dd MMM yyyy"
//                               {...props}
//           />
//           { error && <Error>{error.message}</Error> }
//         </>
//     )

// }

export const DatePicker = (props) => {
  return (

    <DateTimePicker
      timeFormat={false}
      dateFormat="DD MMMM YYYY"
      icon={<CalendarTodayIcon />}
      {...props}
    />

  );
};

export const TimePicker = ({ fieldProps, ...props }) => {
  const classes = useStyles();
  const { field } = fieldProps;
  const onChange = (newValue) => {
    field.onChange(newValue);
  };
  const fixed_value = (field.value && moment(field.value).toDate()) || null;

  return (
    <div className={classes.inputRow2}>
      <MuiTimePicker
        variant="inline"
        autoOk
        id="time-picker"
        ampm={false}
        value={fixed_value}
        onChange={onChange}
        className={classes.timePickerMain}
        inputProps={{ className: classes.timeInput }}
      />
    </div>
  );

  // return <DateTimePicker timeFormat={"HH:mm"} dateFormat={false} icon={<AccessTimeIcon/>} {...props} />
};

const DateTimePicker = ({
  timeFormat,
  dateFormat,
  icon,
  fieldProps,
  placeholder,
  ...props
}) => {
  const {
    setValue,
    fieldState: { isTouched, error },
  } = fieldProps;
  const { field } = fieldProps;
  const classes = useStyles();

  const renderInput = (props, openCalendar, closeCalendar) => {
    return (
      <div className={[classes.inputRow]} onClick={openCalendar}>
        <IconButton
          aria-label="delete"
          style={{
            lineHeight: "0px",
            padding: "0px",
            marginRight: "6px",
          }}
        >
          {icon}
        </IconButton>
        {props.value || placeholder}
      </div>
    );
  };
  const fixed_value = (field.value && moment(field.value).toDate()) || null;

  return (
    <div className={classes.inputRow}>
    <MuiDatePicker
      variant="inline"
      value={fixed_value}
      onChange={field.onChange}
      className={classes.timePickerMain}
      autoOk
    />
    </div>
    // <ReactDatetime
    //   inputProps={{ placeholder: placeholder}}
    //   closeOnSelect={true}
    //   onChange={field.onChange}
    //   value={fixed_value}
    //   timeFormat={timeFormat}
    //   dateFormat={dateFormat}
    //   renderInput={renderInput}
    // />
  );
};
